import type { Template } from "@/types";

export const LA_06_H5_V1: Template[] = [
{
    id: "la-06-h5v1-01",
    name: "LA 01 - H5V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 73, y: 40, width: 196, height: 126, rotation: 0, imageRotation: 0 },
            { id: "2", x: 73, y: 174, width: 196, height: 126, rotation: 0, imageRotation: 0 },
            { id: "3", x: 73, y: 308, width: 196, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 276, y: 40, width: 287, height: 394, rotation: 0, imageRotation: 0 },
            { id: "5", x: 793, y: 40, width: 324, height: 195, rotation: 0, imageRotation: 0 },
            { id: "6", x: 793, y: 242, width: 324, height: 194, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h5v1-02",
    name: "LA 02 - H5V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 104, y: 40, width: 278, height: 394, rotation: 0, imageRotation: 0 },
            { id: "2", x: 388, y: 40, width: 136, height: 93, rotation: 0, imageRotation: 0 },
            { id: "3", x: 388, y: 141, width: 136, height: 93, rotation: 0, imageRotation: 0 },
            { id: "4", x: 388, y: 241, width: 136, height: 93, rotation: 0, imageRotation: 0 },
            { id: "5", x: 388, y: 342, width: 136, height: 93, rotation: 0, imageRotation: 0 },
            { id: "6", x: 724, y: 94, width: 465, height: 287, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h5v1-03",
    name: "LA 03 - H5V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 84, y: 76, width: 232, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 323, y: 76, width: 231, height: 159, rotation: 0, imageRotation: 0 },
            { id: "3", x: 323, y: 242, width: 231, height: 159, rotation: 0, imageRotation: 0 },
            { id: "4", x: 758, y: 49, width: 396, height: 246, rotation: 0, imageRotation: 0 },
            { id: "5", x: 758, y: 302, width: 194, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 959, y: 302, width: 194, height: 126, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h5v1-04",
    name: "LA 04 - H5V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 148, y: 33, width: 317, height: 192, rotation: 0, imageRotation: 0 },
            { id: "2", x: 148, y: 232, width: 155, height: 102, rotation: 0, imageRotation: 0 },
            { id: "3", x: 148, y: 342, width: 155, height: 102, rotation: 0, imageRotation: 0 },
            { id: "4", x: 310, y: 232, width: 155, height: 102, rotation: 0, imageRotation: 0 },
            { id: "5", x: 310, y: 342, width: 155, height: 102, rotation: 0, imageRotation: 0 },
            { id: "6", x: 800, y: 33, width: 311, height: 410, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h5v1-05",
    name: "LA 05 - H5V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 67, y: 72, width: 504, height: 334, rotation: 0, imageRotation: 0 },
            { id: "2", x: 760, y: 46, width: 192, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 760, y: 177, width: 192, height: 123, rotation: 0, imageRotation: 0 },
            { id: "4", x: 760, y: 307, width: 192, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 959, y: 307, width: 192, height: 123, rotation: 0, imageRotation: 0 },
            { id: "6", x: 959, y: 46, width: 192, height: 255, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h5v1-06",
    name: "LA 06 - H5V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 58, y: 83, width: 224, height: 151, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 241, width: 224, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 290, y: 83, width: 223, height: 151, rotation: 0, imageRotation: 0 },
            { id: "4", x: 290, y: 241, width: 223, height: 150, rotation: 0, imageRotation: 0 },
            { id: "5", x: 521, y: 83, width: 202, height: 307, rotation: 0, imageRotation: 0 },
            { id: "6", x: 730, y: 83, width: 486, height: 307, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h5v1-07",
    name: "LA 07 - H5V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 57, y: 83, width: 224, height: 151, rotation: 0, imageRotation: 0 },
            { id: "2", x: 57, y: 241, width: 224, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 289, y: 83, width: 202, height: 307, rotation: 0, imageRotation: 0 },
            { id: "4", x: 498, y: 83, width: 224, height: 151, rotation: 0, imageRotation: 0 },
            { id: "5", x: 498, y: 241, width: 224, height: 150, rotation: 0, imageRotation: 0 },
            { id: "6", x: 730, y: 83, width: 486, height: 307, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h5v1-08",
    name: "LA 08 - H5V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 57, y: 83, width: 224, height: 151, rotation: 0, imageRotation: 0 },
            { id: "2", x: 57, y: 241, width: 224, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 289, y: 83, width: 202, height: 307, rotation: 0, imageRotation: 0 },
            { id: "4", x: 498, y: 83, width: 486, height: 307, rotation: 0, imageRotation: 0 },
            { id: "5", x: 992, y: 83, width: 224, height: 151, rotation: 0, imageRotation: 0 },
            { id: "6", x: 992, y: 241, width: 224, height: 150, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h5v1-09",
    name: "LA 09 - H5V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 47, y: 38, width: 280, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 334, y: 38, width: 258, height: 155, rotation: 0, imageRotation: 0 },
            { id: "3", x: 334, y: 287, width: 258, height: 153, rotation: 0, imageRotation: 0 },
            { id: "4", x: 334, y: 199, width: 126, height: 81, rotation: 0, imageRotation: 0 },
            { id: "5", x: 466, y: 199, width: 125, height: 81, rotation: 0, imageRotation: 0 },
            { id: "6", x: 598, y: 38, width: 629, height: 402, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h5v1-10",
    name: "LA 10 - H5V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 101, y: 38, width: 149, height: 96, rotation: 0, imageRotation: 0 },
            { id: "2", x: 101, y: 141, width: 149, height: 95, rotation: 0, imageRotation: 0 },
            { id: "3", x: 101, y: 243, width: 149, height: 95, rotation: 0, imageRotation: 0 },
            { id: "4", x: 101, y: 345, width: 149, height: 95, rotation: 0, imageRotation: 0 },
            { id: "5", x: 257, y: 38, width: 279, height: 402, rotation: 0, imageRotation: 0 },
            { id: "6", x: 544, y: 38, width: 629, height: 402, rotation: 0, imageRotation: 0 }
    ],
}
];